import { render, staticRenderFns } from "./RestrictionsHistory.vue?vue&type=template&id=2099106e&"
import script from "./RestrictionsHistory.vue?vue&type=script&lang=js&"
export * from "./RestrictionsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports